import React from 'react';
import './Overlays.css'

const SUIT_SYM  = { S: '♠', H: '♥', D: '♦', C: '♣' };
const SUIT_NAME = { S: 'Spades', H: 'Hearts', D: 'Diamonds', C: 'Clubs' };

// Same dynamic generator
function getTeamNames(mode, players) {
  const getNames = (indices) => {
    return indices
      .map(i => (players && players[i] && players[i].name) ? players[i].name : `P${i+1}`)
      .join(' & ');
  };

  if (mode === '56') {
    return [
      `Team ♦ (${getNames([0, 2, 4])})`,
      `Team ♠ (${getNames([1, 3, 5])})`
    ];
  }
  return [
    `Team ♦ (${getNames([0, 2])})`,
    `Team ♠ (${getNames([1, 3])})`
  ];
}

export default function RoundOverPanel({ gs, myId, send }) {
  const lr = gs.last_round;
  if (!lr) return null;
  
  // Pass the players array
  const teams = getTeamNames(gs.mode, gs.players);
  const winTeam  = lr.success ? Number(lr.bid_team) : 1 - Number(lr.bid_team);

  const myPlayerObj = gs.players && gs.players[myId];
  const isHost = myPlayerObj && myPlayerObj.id === gs.host_id;

  return (
    <div className="phase-panel">
      <h3>Round Over</h3>
      <div className="result-bid-info">
        Bid: <strong style={{ color: '#fcd34d' }}>{lr.bid}</strong>
        {lr.redoubled ? (
          <span className="multiplier-badge x4" style={{ verticalAlign: 'middle', marginLeft: 6, padding: '2px 6px' }}>x4</span>
        ) : lr.doubled ? (
          <span className="multiplier-badge" style={{ verticalAlign: 'middle', marginLeft: 6, padding: '2px 6px' }}>x2</span>
        ) : null}
        {lr.escalation_mult > 1 && (
          <span style={{ verticalAlign: 'middle', marginLeft: 6, padding: '2px 6px', background: lr.escalation_mult === 4 ? '#ff4d4d' : '#ffcc00', color: '#000', borderRadius: '4px', fontSize: '0.8rem', fontWeight: 'bold' }}>
            ESCALATION x{lr.escalation_mult}
          </span>
        )}
        {lr.royal_pair_team !== -1 && <span title="Royal Pair" style={{ marginLeft: 8 }}>👑</span>}
        {lr.trump_revealed ? ` · Trump: ${SUIT_SYM[lr.trump_suit] || '?'} ${SUIT_NAME[lr.trump_suit] || ''}` : ' · Trump never revealed'}
      </div>
      <div className="result-scores">
        <div className={`result-team ${winTeam === Number(lr.bid_team) ? 'winner' : ''}`}>
          <div className="result-team-name">{teams[Number(lr.bid_team)]} (bid)</div>
          <div className="result-team-pts">{lr.team_pts[Number(lr.bid_team)]}</div>
          <div className="result-team-match">
            {lr.success ? `✓ Made it! (+${lr.delta})` : `✗ Failed (${lr.delta})`}
            {lr.contract_target !== lr.bid && (
              <div style={{ fontSize: '0.7rem', opacity: 0.8 }}>Target was adjusted to {lr.contract_target}</div>
            )}
          </div>
        </div>
        <div className={`result-team ${winTeam !== Number(lr.bid_team) ? 'winner' : 'loser'}`}>
          <div className="result-team-name">{teams[1 - Number(lr.bid_team)]} (def)</div>
          <div className="result-team-pts">{lr.team_pts[1 - Number(lr.bid_team)]}</div>
          <div className="result-team-match">no change</div>
        </div>
      </div>
      {gs.player_analyses && gs.player_analyses[myId] && (
        <div style={{
          marginTop: 16, 
          padding: '12px', 
          background: 'rgba(20, 25, 40, 0.6)', 
          border: '1px solid rgba(212, 175, 55, 0.3)', 
          borderRadius: '8px', 
          textAlign: 'left'
        }}>
          <h4 style={{ margin: '0 0 8px 0', color: '#d4af37', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>🧠</span> AI Hand Analysis
          </h4>
          <p style={{ margin: '0 0 6px 0', fontSize: '0.85rem', color: '#cbd5e1' }}>
            Evaluated against the final bid of <strong>{lr.bid}</strong>
          </p>
          <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '0.85rem', color: '#e2e8f0', display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <li>If you had secured the bid with your best suit ({SUIT_SYM[gs.player_analyses[myId].best_suit] || ''} {SUIT_NAME[gs.player_analyses[myId].best_suit] || gs.player_analyses[myId].best_suit}): <strong style={{ color: gs.player_analyses[myId].bid_winner_pct > 0.6 ? '#4ade80' : gs.player_analyses[myId].bid_winner_pct < 0.4 ? '#f87171' : '#fcd34d' }}>{Math.round(gs.player_analyses[myId].bid_winner_pct * 100)}% chance to win</strong></li>
            <li>Defending blindly against the bid: <strong style={{ color: gs.player_analyses[myId].defender_pct > 0.6 ? '#4ade80' : gs.player_analyses[myId].defender_pct < 0.4 ? '#f87171' : '#fcd34d' }}>{Math.round(gs.player_analyses[myId].defender_pct * 100)}% chance to win</strong></li>
          </ul>
        </div>
      )}

      <div style={{ marginTop: 16 }}>
        {isHost ? (
          <button className="btn btn-primary" style={{ fontSize: '0.9rem' }} onClick={() => send('next_round', {})}>
            Next Round →
          </button>
        ) : (
          <p style={{ color: '#94a3b8', fontStyle: 'italic', margin: 0 }}>
            Waiting for host to start next round...
          </p>
        )}
      </div>
    </div>
  );
} 